import React from 'react';
import {EdapProvider} from '@homeaway/react-event-tracking';
import FilterBar from '../FilterBar/FilterBar';
import FilterForm from '../FilterForm/FilterForm';
import {ErrorReportBoundary} from '@homeaway/react-error-reporter';
import Experiment, {On, Off} from '@homeaway/react-experiment';
import {VRBO_WEB_SEARCH_NEW_FILTER_MENU} from '../../abacus/experiments';
import FilterBarV2 from '../FilterBarV2/FilterBarV2';
import MoreFiltersModal from '../MoreFiltersModal/MoreFiltersModal';

function FiltersContainer(props) {
    const {filterCountDataProvider: FilterCountDataProvider} = props;
    const eventcategory = {eventcategory: 'search'};

    return (
        <EdapProvider>
            <ErrorReportBoundary
                name={'Filters threw an error'}
                // onError callback to hide any overlay (old experience) in case the component crashes
                onError={
                    /* istanbul ignore next */
                    () => props.hideOverlay && props.hideOverlay()
                }
            >
                <Experiment name={VRBO_WEB_SEARCH_NEW_FILTER_MENU}>
                    <On>
                        <FilterCountDataProvider
                            searchResultsLoading={props.searchResultsLoading}
                        >
                            {({filterGroups, resultsCount}) => {
                                const {
                                    allFiltersButtonCustomTrigger,
                                    allFiltersButtonOnly,
                                    clearFilters,
                                    currency,
                                    filter,
                                    filterByTotalPrice,
                                    inputFilterByTotalPrice,
                                    inputMaxNightlyPrice,
                                    inputMaxTotalPrice,
                                    inputMinBathrooms,
                                    inputMinBedrooms,
                                    inputMinNightlyPrice,
                                    inputMinTotalPrice,
                                    inputParams,
                                    isMobile,
                                    maxNightlyPrice,
                                    maxTotalPrice,
                                    minBathrooms,
                                    minBedrooms,
                                    minNightlyPrice,
                                    minTotalPrice,
                                    params,
                                    priceFilterOptions,
                                    priceInputValuesAreValid,
                                    syncInputParams,
                                    updateFilterCheck,
                                    updateInputParams,
                                    updateMultipleFilterCheck,
                                    updatePriceInputValuesValidity,
                                } = props;
                                const commonProps = {
                                    isMobile,
                                    currency,
                                    customFiltersParams: {
                                        appliedFilterByTotalPrice: filterByTotalPrice,
                                        appliedMaxNightlyPrice: maxNightlyPrice,
                                        appliedMaxTotalPrice: maxTotalPrice,
                                        appliedMinBathrooms: minBathrooms,
                                        appliedMinBedrooms: minBedrooms,
                                        appliedMinNightlyPrice: minNightlyPrice,
                                        appliedMinTotalPrice: minTotalPrice,
                                        selectedFilterByTotalPrice: inputFilterByTotalPrice,
                                        selectedMaxNightlyPrice: inputMaxNightlyPrice,
                                        selectedMaxTotalPrice: inputMaxTotalPrice,
                                        selectedMinBathrooms: inputMinBathrooms,
                                        selectedMinBedrooms: inputMinBedrooms,
                                        selectedMinNightlyPrice: inputMinNightlyPrice,
                                        selectedMinTotalPrice: inputMinTotalPrice,
                                    },
                                    selectedFilters: inputParams.filter,
                                    appliedFilters: params.filter,
                                    filterGroups,
                                    onClear: clearFilters,
                                    onCustomFilterUpdate: updateInputParams,
                                    onDismiss: syncInputParams,
                                    onDone: filter,
                                    onFilterToggle: updateFilterCheck,
                                    onMultipleFilterToggle: updateMultipleFilterCheck,
                                    priceFilterOptions,
                                    priceInputValuesAreValid,
                                    updatePriceInputValuesValidity,
                                    results: resultsCount,
                                    displayNumGroupsAsPills:
                                        props.displayNumGroupsAsPills,
                                };

                                if (allFiltersButtonOnly) {
                                    return (
                                        <MoreFiltersModal
                                            {...commonProps}
                                            id="all-filters"
                                            sliceAt={0}
                                            allFiltersButtonCustomTrigger={
                                                allFiltersButtonCustomTrigger
                                            }
                                        />
                                    );
                                }

                                return <FilterBarV2 {...commonProps} />;
                            }}
                        </FilterCountDataProvider>
                    </On>
                    <Off>
                        <EdapProvider fields={eventcategory}>
                            {props.isMobile ? (
                                <FilterForm {...props} />
                            ) : (
                                <FilterBar {...props} />
                            )}
                        </EdapProvider>
                    </Off>
                </Experiment>
            </ErrorReportBoundary>
        </EdapProvider>
    );
}

export default FiltersContainer;
export {FiltersContainer as Filters};
